export default "__VITE_ASSET__C7zP$Eqn__"